import React, {Component} from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import InputMask from 'react-input-mask';

class ProfileAccess extends Component{
  constructor(props){
    super(props);
    var generator = require('generate-password');
    var password = generator.generate({
        length: 10,
        numbers: true
    });
    this.state = {
      loading:true,
      hideInactive:true,
      accountSearch:'',
      // New assignments default to an active Manage grant that receives the weekly report,
      // so the common case is: search -> pick -> Save (view reviews + analysis + weekly email).
      user:{id:0, account_id:0, first_name:'', last_name:'', email:'', password:password, sys_role_id:3, is_email:1, sys_status_id:1}
    }
  }

  handleInputChange = (e) => {
    let updated_user = Object.assign({}, this.state.user);
    const value = e.target.value;
    updated_user[e.target.name] = value;
    if (e.target.name === 'is_email') {
      if (e.target.checked){
        updated_user.is_email = 1;
      } else {
        updated_user.is_email = 0;
      }
    }
    if (e.target.name === 'sys_status_id') {
      console.log(e.target.checked);
      if (e.target.checked){
        updated_user.sys_status_id = 1;
      } else {
        updated_user.sys_status_id = 2;
      }
      console.log(updated_user);
    }
    this.setState({user:updated_user});
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.addUser(this.state.user);
    this.reset();
  }

  reset = () => {
    var generator = require('generate-password');
    var password = generator.generate({
        length: 10,
        numbers: true
    });
    this.setState({
      accountSearch:'',
      user:{id:0, account_id:0, first_name:'', last_name:'', email:'', password:password, sys_role_id:3, is_email:1, sys_status_id:1}
    })
  }

  editUser = (user) => {
    let tmp_user = Object.assign({}, this.state.user);
    tmp_user = user;
    this.setState({
      user:tmp_user
    })
  }

  render(){
    if (!this.props.item) return <div>Loading</div>;
    const {hideInactive, available_account_list, account_list, backgroundClickHandler, sys_role_list, item} = this.props;
    const {user} = this.state;
    const search = (this.state.accountSearch || '').toLowerCase();
    const filtered_account_list = (available_account_list || []).filter((a) => {
      if (!search) return true;
      return (((a.email || '') + ' ' + (a.first_name || '') + ' ' + (a.last_name || '')).toLowerCase().indexOf(search) > -1);
    });
    // When adding (id === 0) an account must be chosen; when editing, the row is fixed.
    const isInvalid = user.id === 0 && (!user.account_id || parseInt(user.account_id) === 0);
    let rows = this.props.item.account_list;
    if (this.state.hideInactive){
      rows = rows.filter((x) => x.sys_status_id === 1);
    }
    const columns = [{
      dataField: 'name',
      text: 'Name',
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="text-truncate">
            {row.account_name}
          </div>
        );
      }
    }, {
      dataField: 'email',
      text: 'Email',
      headerClasses: 'd-none d-sm-table-cell',
      classes: 'd-none d-sm-table-cell',
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="text-truncate">
            {row.email}
          </div>
        );
      }
    }, {
      dataField: 'user_role_list',
      text: 'Role',
      headerClasses: 'd-none d-sm-table-cell',
      classes: 'd-none d-sm-table-cell',
      sort: false,
      formatter: (cellContent, row) => {
        return (
          <span className="badge badge-default">{row.sys_role}</span>
        )
      }
    }, {
      dataField: 'is_email',
      text: 'Rec. Email',
      headerClasses: 'd-none d-sm-table-cell',
      classes: 'd-none d-sm-table-cell',
      sort: false,
      formatter: (cellContent, row) => {
        if (parseInt(row.is_email) === 0 || !row.is_email){
          return (
            <span className="badge badge-danger">No</span>
          )
        } else {
          return (
            <span className="badge badge-success">Yes</span>
          )
        }
      }
    }, {
      dataField: 'sys_status_id',
      text: 'Status',
      headerClasses: 'd-none d-sm-table-cell',
      classes: 'd-none d-sm-table-cell',
      sort: false,
      formatter: (cellContent, row) => {
        console.log(row.sys_status_id)
        if (row.sys_status_id && parseInt(row.sys_status_id) === 1){
          return (
            <span className="badge badge-success">ACTIVE</span>
          )
        } else {
          return (
            <span className="badge badge-danger">INACTIVE</span>
          )
        }
      }
    },{
      dataField: 'Actions',
      isDummyField: true,
      text: 'Actions',
      formatter: (cellContent, row) => {
        return (
          <button className="btn btn-primary" onClick={()=>this.editUser(row)}>Edit</button>
        );
      }
    }];
    return (
      <React.Fragment>
        <h3 className="m-t-0"><i className="pg-icon">users</i> Access</h3>
        <form role="form" id="form-profile-account" onSubmit={this.handleSubmit}>
          {user.id !== 0 ?
            <h3>Update user access</h3>
          :
            <h3>Add user access</h3>
          }
          <div className="form-group-attached">
            <div className="row">
              <div className="col-md-3">
              {user.id !== 0 ?
                <div className="form-group form-group-default">
                  <label>Selected Account</label>
                  <input type="text" className="form-control"  value={user.email} disabled/>
                </div>
              :
                <React.Fragment>
                <div className="form-group form-group-default">
                  <label>Find Account</label>
                  <input type="text" className="form-control" placeholder="name or email" value={this.state.accountSearch} onChange={(e)=>this.setState({accountSearch:e.target.value})}/>
                </div>
                <div className="form-group form-group-default">
                  <label>Account</label>
                  <select className="form-control" name="account_id" value={user.account_id} onChange={this.handleInputChange}>
                    <option value="">Select Account ({filtered_account_list.length})</option>
                    {filtered_account_list.map((account, acc_index)=>
                      <option key={acc_index} value={account.id}>{account.email}{(account.first_name || account.last_name) ? ' — ' + ((account.first_name || '') + ' ' + (account.last_name || '')).trim() : ''}</option>
                    )}
                  </select>
                </div>
                </React.Fragment>
              }
              </div>
              <div className="col-md-6">
                <div className="form-group form-group-default">
                  <label>Roles</label>
                  {sys_role_list.map((role, role_index)=>
                    <div key={role_index}  className="form-check primary">
                      <input type="radio" name="sys_role_id" id={role_index} onChange={this.handleInputChange} value={role.id} checked={parseInt(user.sys_role_id) === role.id ? 'checked' : null}/>
                      <label htmlFor={role_index}>{role.name}: <small className="text-hint fs-10">{role.description}</small></label>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group form-group-default">
                  <div className="form-check primary">
                    <input type="checkbox" name="is_email" id="is_email" onChange={this.handleInputChange} value={user.is_email} checked={parseInt(user.is_email) === 1 ? 'checked' : null}/>
                    <label htmlFor="is_email">Receive Weekly Emails?</label>
                  </div>
                  <div className="form-check primary">
                    <input type="checkbox" name="sys_status_id" id="sys_status_id" onChange={this.handleInputChange} value={user.sys_status_id} checked={parseInt(user.sys_status_id) === 1 ? 'checked' : null}/>
                    <label htmlFor="sys_status_id">Active?</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row m-t-10 m-b-5">
            <div className="col-12">
              <div className="btn-group pull-right">
                <button className="btn btn-default" type="button" onClick={()=>this.setState({hideInactive:!this.state.hideInactive})}>Hide/Show Inactive</button>
                <button className="btn btn-default" type="button" onClick={this.reset}>Cancel</button>
                <button className={isInvalid ? "btn btn-primary disabled" : "btn btn-primary"} type="submit">Save</button>
              </div>
            </div>
          </div>
        </form>
        <div className="table-responsive">
          <BootstrapTable keyField='id' classes='table-condensed table table-striped table-hover table-bordered' data={rows} columns={columns} striped hover headerClasses="thead-light"/>
        </div>
    </React.Fragment>
    )
  }
}

export default ProfileAccess;
